/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable no-nested-ternary */
import {
  Avatar, Button, Divider, IconButton, Rating, Stack,
} from '@mui/material';
import React, { useState } from 'react';
import { AiFillCaretDown, AiOutlineMessage } from 'react-icons/ai';
import Tooltip from '@mui/material/Tooltip';
import './ReviewList.css';
//   import color from '../common/Colors';
//   import { Button as Button } from '../common/Button/Button';
  
const actionsOptions = [
  { label: 'Update who assisted reviewer', value: 'Update who assisted reviewer' },
  { label: 'Share on Facebook', value: 'Share on Facebook' },
  { label: 'Share on Twitter', value: 'Share on Twitter' },
  { label: 'Share on LinkedIn', value: 'Share on LinkedIn' },
  { label: 'Recommend on profile', value: 'Recommend on profile' },
];
  
const limitedText = 500;
  
function ReviewList({
  name, comment, createTime,replied, reply, star,
  sourceLogo,source ,responsePlatform,responseCreated,
}) {
  const [action, setAction] = useState('');
  const [showMore, setShowMore] = useState(false);
  const [replyDrawer, setReplyDrawer] = useState(false);
  const message = 'The user didn\'t write a review, and has just left a rating.';
  return (
    <div className="w-full px-5 pt-5 sm:px-8">
      {/* REVIEW HEADER */}
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Avatar
          alt="Remy Sharp"
          src={sourceLogo}
          sx={{
            width: 44, height: 44, bgcolor: '#f1f5f9', border: '1px solid #e2e8f0',
          }}
        />
        <Stack sx={{ minWidth: 0 }}>
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <div className="text-[15px] font-medium text-slate-900">{name}</div>
            <div className="text-xs font-normal text-slate-400">{new Date(createTime).toLocaleString()}</div>
          </div>
          <div className="mt-1 flex items-center">
            <Rating 
              sx={{ color: '#f59e0b' ,fontSize: '15px' }}
              color="secondary"
              name="read-only"
              value={Number(star)}
              precision={0.5}
              readOnly
            />
            <div 
              className="ml-2 rounded-full bg-blue-50 px-2 py-0.5 text-blue-600 ring-1 ring-blue-100" 
              style={{ 
                fontSize: '11px',
              }}
            >
              {source.toString().charAt(0).toUpperCase() + source.slice(1)}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            {/* <div className="text-[14px] font-normal text-[#b6b8b9]">
              <Tooltip title="Show Details">
                <div>
                  <AiFillCaretDown />
                </div>                
              </Tooltip>
            </div> */}
          </div>
        </Stack>
      </Stack>
  
      {/* REVIEW CONTENT */}
      {comment?.length > 0 && (
      
      <div 
        className="mt-3 rounded-xl bg-slate-50 p-4 text-sm leading-relaxed text-slate-700 sm:ml-[60px]"
      >
        <div className="review-text" style={{ testAlign: 'justify' }}>
          {/* When content is bigger than 500 words */}
          {comment?.length > limitedText ? (
            <span className="detailed-review-text">
              {showMore ? comment : `${comment.slice(0, limitedText)}...`}
              <Button
                variant="text"
                sx={{
                  fontFamily: 'inherit', fontWeight: 500, textTransform: 'lowercase', span: 0, m: 0, ml: 1, backgroundColor: '#eff6ff', borderRadius: '9999px', height: '26px', fontSize: '12px', 
                }}
                onClick={() => setShowMore(!showMore)}
              >
                {showMore ? '- less' : 'more +'}
              </Button>
            </span>
          ) : (comment?.length === 0 ? (
            <span className="no-review-message">
              {message}
              {' '}
            </span>
          ) : (comment))}
            
        </div>
      </div>
      )} 

      {replied ? (
        <div style={{ width: '100%' }}>
          <div>
            {reply?.length > 0 ? (
              <div className="reply-review-header">
                <div className="reply-review-header-text">  
                  Business response on
                </div>
                <div className="reply-review-header-name">
                  {responsePlatform} 
                </div>
                <div className="reply-review-header-text">  
                  {new Date(responseCreated).toLocaleString('en-US', {
                    timeZone: 'America/New_York',
                    // weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </div>
         
              </div>
            ) : ''}
          </div>
  
          <div 
            className="mt-2 rounded-xl border-l-4 border-blue-200 bg-white p-4 text-sm leading-relaxed text-slate-600 ring-1 ring-slate-100 sm:ml-[60px]"
            style={{ display: reply?.length !== 0 ? 'block' : 'none' }}
          >
            {reply}
          </div> 
        </div>
      ) : null}
  
      <div className="mt-5">
        <Divider sx={{ borderColor: '#f1f5f9' }} />
      </div>
  
    </div>
  );
}
// }
export default ReviewList;
